import React from 'react';

import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

import { renderOptions } from 'services/contentful/renderText';

import * as T from '../Articles/Articles.types';
import * as S from './Intern.style';

export const Intern: React.FC<T.CasesdeSucessoContentCollection> = ({ items }) => {
  return (
    <S.CaseInterna>
      {items.map((item) => {
        return (
          <div key={item.title} className="content">
            {documentToReactComponents(item.content?.json, renderOptions(item.content?.links))}
          </div>
        );
      })}
    </S.CaseInterna>
  );
};
